import {
  Alarm,
  Archive,
  ArrowCounterClockwise,
  ArrowElbowDownRight,
  ArrowLeft,
  ArrowLineRight,
  ArrowRight,
  ArrowsClockwise,
  ArrowsCounterClockwise,
  ArrowsOutCardinal,
  ArrowsSplit,
  ArrowUUpLeft,
  Barricade,
  BookOpenText,
  Briefcase,
  Broom,
  Bulldozer,
  Calendar,
  CalendarStar,
  CaretDown,
  CaretLeft,
  CaretRight,
  ChartBar,
  Check,
  CheckCircle,
  CheckSquare,
  Circle,
  City,
  ClipboardText,
  Clock,
  ClockCountdown,
  ClockCounterClockwise,
  ClockUser,
  CloudMoon,
  Columns,
  CompassTool,
  Confetti,
  Copy,
  CraneTower,
  DotsNine,
  DotsThreeVertical,
  Download,
  Engine,
  EnvelopeSimple,
  Eye,
  EyeSlash,
  Factory,
  File,
  FileDashed,
  FileMagnifyingGlass,
  FilePlus,
  FileZip,
  Flask,
  FloppyDisk,
  Funnel,
  Garage,
  Gear,
  GearFine,
  GlobeHemisphereWest,
  GpsFix,
  GraduationCap,
  HouseLine,
  IconBase,
  IdentificationCard,
  Info,
  Lightbulb,
  Lightning,
  Link,
  ListChecks,
  MagicWand,
  MagnifyingGlass,
  Mailbox,
  Minus,
  Money,
  Moon,
  Notebook,
  Nut,
  Package,
  Pause,
  PencilSimple,
  PipeWrench,
  Play,
  PlayCircle,
  Plus,
  Prohibit,
  Question,
  Receipt,
  SealCheck,
  SealQuestion,
  SealWarning,
  Shapes,
  ShareNetwork,
  ShieldPlus,
  SignOut,
  Skull,
  Sparkle,
  Square,
  Stack,
  Stop,
  Storefront,
  Sun,
  Swap,
  Table,
  Tag,
  Timer,
  Trash,
  TreeView,
  Upload,
  User,
  UserCircle,
  UserCircleCheck,
  UserFocus,
  UserGear,
  UserPlus,
  Users,
  Warning,
  WarningOctagon,
  WifiHigh,
  WifiX,
  Wrench,
  X,
} from "@phosphor-icons/react";

import {
  Counter,
  Device,
  DeviceModel,
  Identifier,
  PartAssembly,
  PartDisassembly,
  PartModel,
  TagAdd,
  TagMultiple,
  UserInvite,
} from "@/utils/iconsCustom";

export const Icon = IconBase as typeof IconBase & {
  // ! CRUD
  CREATE: typeof Plus;
  DELETE: typeof Trash;
  PAUSE: typeof Pause;
  REMOVE: typeof X;
  REVOKE: typeof ArrowUUpLeft;
  EDIT: typeof PencilSimple;
  SAVE: typeof FloppyDisk;
  CANCEL: typeof Prohibit;
  PUBLISH: typeof Eye;
  CLEAR: typeof X;
  UNDO: typeof ArrowCounterClockwise;
  // ! ENTITIES
  WORKSPACE: typeof HouseLine;
  WORKSPACES: typeof City;
  WORKSPACE_DETAILS: typeof GearFine;
  WORKSPACE_PROFILE: typeof IdentificationCard;
  WORKSPACE_INVITATIONS: typeof UserInvite;
  DEPLOYMENT: typeof Garage;
  DEPLOYMENT_INVITATIONS: typeof EnvelopeSimple;
  DEVICE: typeof Device;
  DEVICE_MODEL: typeof DeviceModel;
  MANUFACTURER: typeof Factory;
  MODEL: typeof Device;
  PART_MANUFACTURER: typeof Factory;
  PART_CATEGORY: typeof Shapes;
  PART_MODEL: typeof PartModel;
  PART_REF: typeof Identifier;
  PART_ASSEMBLY: typeof PartAssembly;
  PART_DISASSEMBLY: typeof PartDisassembly;
  PART_DISASSEMBLY_TRASH: typeof Trash;
  PART_CLEANING: typeof Broom;
  PART_CALIBRATE: typeof CompassTool;
  PART_REPAIR: typeof PipeWrench;
  PART_UPDATE: typeof ArrowsClockwise;
  PART_PRICE: typeof Money;
  PART_LOCATION: typeof GpsFix;
  PART: typeof Nut;
  PART_COUNT: typeof Counter;
  CASE: typeof Receipt;
  TAG: typeof Tag;
  TAG_ADD: typeof TagAdd;
  MAINTENANCE_TAG: typeof Tag;
  MAINTENANCE_TAGS: typeof TagMultiple;
  DEVICE_TAG: typeof Tag;
  DEVICE_TAGS: typeof TreeView;
  CASE_TAG: typeof Tag;
  CASE_TAGS: typeof TagMultiple;
  MAINTENANCE: typeof Wrench;
  MAINTENANCE_STRATEGY: typeof CalendarStar;
  STRATEGY_INTERVAL: typeof ClockCountdown;
  STRATEGY_USAGE: typeof Engine;
  STRATEGY_ANOMALY: typeof SealWarning;
  DAILYTASK: typeof UserCircleCheck;
  TASK: typeof SealCheck;
  CHECKLIST_TEMPLATE: typeof ListChecks;
  USER: typeof User;
  USERS: typeof Users;
  USER_SETTINGS: typeof UserGear;
  USER_MENU: typeof UserCircle;
  DAILY_SUMMARY: typeof UserFocus;
  SERVICE_CONTRACT: typeof FileDashed;
  MISSION: typeof Briefcase;
  SETTINGS: typeof Gear;
  DEPLOYMENT_SETTINGS: typeof Gear;
  // ! Orders
  ORDER_PENDING: typeof SealQuestion;
  ORDER_STARTED: typeof PlayCircle;
  ORDER_FINISHED: typeof Check;
  ORDER_ABORTED: typeof Prohibit;
  // ! Device Types
  AUTONOMOUS: typeof Device;
  STATIONARY: typeof CraneTower;
  MANUAL: typeof Bulldozer;
  // ! Maintenances
  TIMER_START: typeof Timer;
  PENDING: typeof ClockCountdown;
  DUE: typeof Alarm;
  TODAY: typeof ClockUser;
  CLOCK: typeof Clock;
  CALENDAR: typeof Calendar;
  STARTED: typeof PlayCircle;
  SKIPPED: typeof ArrowLineRight;
  // ! Checklist Templates
  CT_PRIVATE: typeof HouseLine;
  CT_PUBLIC: typeof GlobeHemisphereWest;
  CT_SHARED: typeof ShareNetwork;
  // ! Cases
  ARCHIVED: typeof Archive;
  COMPLETED: typeof CheckCircle;
  UNRESOLVED: typeof SealQuestion;
  // ! Workspace Profile
  WP_PUBLIC: typeof Eye;
  WP_PRIVATE: typeof EyeSlash;
  // ! MISC
  ID: typeof Identifier;
  TABLE: typeof Table;
  FINDER: typeof Columns;
  HISTORY: typeof ClockCounterClockwise;
  MOVED_TO_DEPLOYMENT: typeof ArrowsOutCardinal;
  TRIAL: typeof Flask;
  PARTY: typeof Confetti;
  STATUS: typeof ListChecks;
  FILTER: typeof Funnel;
  STORE: typeof Storefront;
  LOGOUT: typeof SignOut;
  SEARCH: typeof MagnifyingGlass;
  DOWNLOAD: typeof Download;
  CALIBRATE: typeof CompassTool;
  UPDATE: typeof ArrowsClockwise;
  UPLOAD: typeof Upload;
  FILE: typeof File;
  FILE_PREVIEW: typeof FileMagnifyingGlass;
  FILE_ADD: typeof FilePlus;
  FILE_MISSING: typeof FileDashed;
  FILE_ZIP: typeof FileZip;
  LINK: typeof Link;
  DRAGNDROP: typeof DotsNine;
  CHART: typeof ChartBar;
  INSIGHTS: typeof Sparkle;
  HELP: typeof Question;
  WARNING: typeof Warning;
  ERROR: typeof WarningOctagon;
  INFO: typeof Info;
  GO_FORWARD: typeof ArrowRight;
  GO_BACK: typeof ArrowLeft;
  GO_FORWARD_CHEVRON: typeof CaretRight;
  GO_BACK_CHEVRON: typeof CaretLeft;
  GO_DOWN_RIGHT: typeof ArrowElbowDownRight;
  RESET: typeof ArrowCounterClockwise;
  CHECK: typeof Check;
  EXPAND: typeof CaretRight;
  COLLAPSE: typeof CaretDown;
  CHECKBOX_OPEN: typeof Square;
  CHECKBOX_DONE: typeof CheckSquare;
  MENU_VERTICAL: typeof DotsThreeVertical;
  PLAY: typeof Play;
  STOP: typeof Stop;
  DOT: typeof Circle;
  INVITE: typeof UserPlus;
  EMAIL_SENT: typeof Mailbox;
  INSTRUCTIONS: typeof BookOpenText;
  MAGIC_ACTION: typeof MagicWand;
  LIGHTMODE: typeof Sun;
  DARKMODE: typeof Moon;
  AUTOMODE: typeof CloudMoon;
  // ! ACADEMY
  ACADEMY: typeof GraduationCap;
  ANOMALY: typeof Skull;
  SOLUTION_PROPOSAL: typeof Lightbulb;
  CLEANING: typeof Broom;
  REPAIRS: typeof PipeWrench;
  TROUBLESHOOTING: typeof Lightning;
  INSTALLATION: typeof Wrench;
  SAFETY: typeof ShieldPlus;
  WORKLOG: typeof ClipboardText;
  COPY: typeof Copy;
  CONNECTION: typeof WifiHigh;
  CONNECTION_OFF: typeof WifiX;
  // ! PARTS
  INVENTORY: typeof Stack;
  INVENTORY_DATE: typeof Calendar;
  INVENTORY_TAKE: typeof Notebook;
  INVENTORY_ACTION_ADD: typeof Plus;
  INVENTORY_ACTION_REMOVE: typeof Minus;
  INVENTORY_ACTION_CHANGE: typeof ArrowsCounterClockwise;
  INVENTORY_ACTION_MOVE: typeof ArrowsOutCardinal;
  INVENTORY_ACTION_ISOLATE: typeof ArrowsSplit;
  INVENTORY_PACKAGE: typeof Package;
  INVENTORY_ACTIVITIES: typeof Swap;
  CONSTRAINTS: typeof Barricade;
  CONSTRAINT_WARN: typeof Warning;
  CONSTRAINT_FAIL: typeof WarningOctagon;
};

// ! CRUD
Icon.CREATE = Plus;
Icon.DELETE = Trash;
Icon.PAUSE = Pause;
Icon.REMOVE = X;
Icon.REVOKE = ArrowUUpLeft;
Icon.EDIT = PencilSimple;
Icon.SAVE = FloppyDisk;
Icon.CANCEL = Prohibit;
Icon.PUBLISH = Eye;
Icon.CLEAR = X;
Icon.UNDO = ArrowCounterClockwise;
// ! ENTITIES
Icon.WORKSPACE = HouseLine;
Icon.WORKSPACES = City;
Icon.WORKSPACE_DETAILS = GearFine;
Icon.WORKSPACE_PROFILE = IdentificationCard;
Icon.WORKSPACE_INVITATIONS = UserInvite;
Icon.DEPLOYMENT = Garage;
Icon.DEPLOYMENT_INVITATIONS = EnvelopeSimple;
Icon.DEVICE = Device;
Icon.DEVICE_MODEL = DeviceModel;
Icon.MANUFACTURER = Factory;
Icon.MODEL = Device;
Icon.PART_MANUFACTURER = Factory;
Icon.PART_CATEGORY = Shapes;
Icon.PART_MODEL = PartModel;
Icon.PART_REF = Identifier;
Icon.PART_ASSEMBLY = PartAssembly;
Icon.PART_DISASSEMBLY = PartDisassembly;
Icon.PART_DISASSEMBLY_TRASH = Trash;
Icon.PART_CLEANING = Broom;
Icon.PART_CALIBRATE = CompassTool;
Icon.PART_REPAIR = PipeWrench;
Icon.PART_UPDATE = ArrowsClockwise;
Icon.PART_PRICE = Money;
Icon.PART_COUNT = Counter;
Icon.PART_LOCATION = GpsFix;
Icon.PART = Nut;
Icon.CASE = Receipt;
Icon.TAG = Tag;
Icon.TAG_ADD = TagAdd;
Icon.MAINTENANCE_TAG = Tag;
Icon.MAINTENANCE_TAGS = TagMultiple;
Icon.DEVICE_TAG = Tag;
Icon.DEVICE_TAGS = TreeView;
Icon.CASE_TAG = Tag;
Icon.CASE_TAGS = TagMultiple;
Icon.MAINTENANCE = Wrench;
Icon.MAINTENANCE_STRATEGY = CalendarStar;
Icon.STRATEGY_INTERVAL = ClockCountdown;
Icon.STRATEGY_USAGE = Engine;
Icon.STRATEGY_ANOMALY = SealWarning;
Icon.DAILYTASK = UserCircleCheck;
Icon.TASK = SealCheck;
Icon.CHECKLIST_TEMPLATE = ListChecks;
Icon.USER = User;
Icon.USERS = Users;
Icon.USER_SETTINGS = UserGear;
Icon.USER_MENU = UserCircle;
Icon.DAILY_SUMMARY = UserFocus;
Icon.SERVICE_CONTRACT = FileDashed;
Icon.MISSION = Briefcase;
Icon.SETTINGS = Gear;
Icon.DEPLOYMENT_SETTINGS = Gear;
// ! Orders
Icon.ORDER_PENDING = SealQuestion;
Icon.ORDER_STARTED = PlayCircle;
Icon.ORDER_FINISHED = Check;
Icon.ORDER_ABORTED = Prohibit;
// ! Device Types
Icon.AUTONOMOUS = Device;
Icon.STATIONARY = CraneTower;
Icon.MANUAL = Bulldozer;
// ! Maintenances
Icon.TIMER_START = Timer;
Icon.PENDING = ClockCountdown;
Icon.DUE = Alarm;
Icon.TODAY = ClockUser;
Icon.CLOCK = Clock;
Icon.CALENDAR = Calendar;
Icon.STARTED = PlayCircle;
Icon.SKIPPED = ArrowLineRight;
// ! Checklist Templates
Icon.CT_PRIVATE = HouseLine;
Icon.CT_PUBLIC = GlobeHemisphereWest;
Icon.CT_SHARED = ShareNetwork;
// ! Cases
Icon.ARCHIVED = Archive;
Icon.COMPLETED = CheckCircle;
Icon.UNRESOLVED = SealQuestion;
// ! Workspace Profile
Icon.WP_PUBLIC = Eye;
Icon.WP_PRIVATE = EyeSlash;
// ! MISC
Icon.ID = Identifier;
Icon.TABLE = Table;
Icon.FINDER = Columns;
Icon.HISTORY = ClockCounterClockwise;
Icon.MOVED_TO_DEPLOYMENT = ArrowsOutCardinal;
Icon.TRIAL = Flask;
Icon.PARTY = Confetti;
Icon.STATUS = ListChecks;
Icon.FILTER = Funnel;
Icon.STORE = Storefront;
Icon.LOGOUT = SignOut;
Icon.SEARCH = MagnifyingGlass;
Icon.DOWNLOAD = Download;
Icon.CALIBRATE = CompassTool;
Icon.UPDATE = ArrowsClockwise;
Icon.UPLOAD = Upload;
Icon.FILE = File;
Icon.FILE_PREVIEW = FileMagnifyingGlass;
Icon.FILE_ADD = FilePlus;
Icon.FILE_MISSING = FileDashed;
Icon.FILE_ZIP = FileZip;
Icon.LINK = Link;
Icon.DRAGNDROP = DotsNine;
Icon.CHART = ChartBar;
Icon.INSIGHTS = Sparkle;
Icon.HELP = Question;
Icon.WARNING = Warning;
Icon.ERROR = WarningOctagon;
Icon.INFO = Info;
Icon.GO_FORWARD = ArrowRight;
Icon.GO_BACK = ArrowLeft;
Icon.GO_FORWARD_CHEVRON = CaretRight;
Icon.GO_BACK_CHEVRON = CaretLeft;
Icon.GO_DOWN_RIGHT = ArrowElbowDownRight;
Icon.RESET = ArrowCounterClockwise;
Icon.CHECK = Check;
Icon.EXPAND = CaretRight;
Icon.COLLAPSE = CaretDown;
Icon.CHECKBOX_OPEN = Square;
Icon.CHECKBOX_DONE = CheckSquare;
Icon.MENU_VERTICAL = DotsThreeVertical;
Icon.PLAY = Play;
Icon.STOP = Stop;
Icon.DOT = Circle;
Icon.INVITE = UserPlus;
Icon.EMAIL_SENT = Mailbox;
Icon.INSTRUCTIONS = BookOpenText;
Icon.MAGIC_ACTION = MagicWand;
Icon.LIGHTMODE = Sun;
Icon.DARKMODE = Moon;
Icon.AUTOMODE = CloudMoon;
// ! ACADEMY
Icon.ACADEMY = GraduationCap;
Icon.ANOMALY = Skull;
Icon.SOLUTION_PROPOSAL = Lightbulb;
Icon.CLEANING = Broom;
Icon.REPAIRS = PipeWrench;
Icon.TROUBLESHOOTING = Lightning;
Icon.INSTALLATION = Wrench;
Icon.SAFETY = ShieldPlus;
Icon.WORKLOG = ClipboardText;
Icon.COPY = Copy;
Icon.CONNECTION = WifiHigh;
Icon.CONNECTION_OFF = WifiX;
// ! PARTS
Icon.INVENTORY = Stack;
Icon.INVENTORY_DATE = Calendar;
Icon.INVENTORY_TAKE = Notebook;
Icon.INVENTORY_ACTION_ADD = Plus;
Icon.INVENTORY_ACTION_REMOVE = Minus;
Icon.INVENTORY_ACTION_CHANGE = ArrowsCounterClockwise;
Icon.INVENTORY_ACTION_MOVE = ArrowsOutCardinal;
Icon.INVENTORY_ACTION_ISOLATE = ArrowsSplit;
Icon.INVENTORY_PACKAGE = Package;
Icon.INVENTORY_ACTIVITIES = Swap;
Icon.CONSTRAINTS = Barricade;
Icon.CONSTRAINT_WARN = Warning;
Icon.CONSTRAINT_FAIL = WarningOctagon;
export default Icon;
